import { Row } from "react-bootstrap";

type Props = {
  title: string;
  children?: React.ReactNode;
};

export const PageContent = ({ children }: Props) => {
  return (
    // ADD BOTTOM MARGIN
    <Row className={`p-3 mb-2`}>
      <div className="mt-4">{children}</div>
    </Row>
  );
};
